import { defineStore } from 'pinia';
import { Template } from '@/entities/template/model';

interface TemplateLibraryState {
  activeTemplate: Template | null;
  isLoading: boolean;
}

const defaultState = (): TemplateLibraryState => ({
  activeTemplate: null,
  isLoading: false,
});

export const useTemplateLibraryStore = defineStore('templateLibrary', {
  state: defaultState,

  actions: {
    async setActiveTemplate(template: Template | null) {
      this.activeTemplate = template;
    },
  },
});
